import { strings } from '../context/LanguageContext/strings'

export const storeConstants = {
    getStoreHeadCells: () => [
        {
            id: 'store_id',
            label: strings.OPS_TOOLS_STORES_STORE_ID_LABEL,
            draggable: false,
            width: '15%',
            align: 'center',
        },
        {
            id: 'address',
            label: strings.OPS_TOOLS_STORES_STREET_ADDRESS_LABEL,
            draggable: false,
            width: '20%',
        },
        { id: 'city', label: strings.OPS_TOOLS_STORES_CITY_LABEL, draggable: false, width: '18%' },
        {
            id: 'state',
            label: strings.OPS_TOOLS_STORES_STATE_LABEL,
            draggable: false,
            width: '18%',
        },
        {
            id: 'store_category',
            label: strings.OPS_TOOLS_STORES_CATEGORY_LABEL,
            draggable: false,
            width: '15%',
            sortable: true,
        },
        // TODO: Hidden column for Hawaii MVP. Might be needed on future iterations
        // {
        //     id: 'mkt_place',
        //     label: strings.OPS_TOOLS_STORES_MARKET_PLACE_LABEL,
        //     draggable: false,
        //     width: '18%',
        // },
        {
            id: 'equipment',
            label: strings.OPS_TOOLS_STORES_EQUIPMENT_LABEL,
            draggable: false,
            width: '18%',
        },
    ],
}
